var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#345D9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5897 20.8889L18.3571 25.1852H24.9501C25.1221 25.1852 25.2941 25.3333 25.2941 25.5111V25.6296L24.7208 27.6741C24.6635 27.8815 24.4915 28 24.2908 28H14.2007L15.8919 22.0444L14 22.637L14.43 21.2741L16.3219 20.6815L18.7011 12.3259C18.7584 12.1185 18.9304 12 19.1311 12H21.6823C21.8543 12 22.0263 12.1481 22.0263 12.3259V12.4444L20.0197 19.4963L21.9116 18.9037L21.5103 20.3259L19.5897 20.8889Z",
    fill: "#345D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5897 20.8889L18.3571 25.1852H24.9501C25.1221 25.1852 25.2941 25.3333 25.2941 25.5111V25.6296L24.7208 27.6741C24.6635 27.8815 24.4915 28 24.2908 28H14.2007L15.8919 22.0444L14 22.637L14.43 21.2741L16.3219 20.6815L18.7011 12.3259C18.7584 12.1185 18.9304 12 19.1311 12H21.6823C21.8543 12 22.0263 12.1481 22.0263 12.3259V12.4444L20.0197 19.4963L21.9116 18.9037L21.5103 20.3259L19.5897 20.8889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin);
export default __webpack_public_path__ + "static/media/litecoin.e46e123bf0049cbd89652e7b46b7c2fe.svg";
export { ForwardRef as ReactComponent };